import * as actions from "./bankAccount.actions";
import * as api from "./bankAccount.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./bankAccount.constants";
import * as hooks from "./bankAccount.hooks";
import * as promises from "./bankAccount.promises";
import reducer from "./bankAccount.reducer";
import { saga } from "./bankAccount.saga";
import * as selectors from "./bankAccount.selectors";
import * as utils from "./bankAccount.utils";
export * from "./bankAccount.types";
export var REDUCER_KEY_BANK_ACCOUNT = REDUCER_KEY;
export var bankAccountModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
